export interface ActivityLinkTarget {
  id: number
}

export class ActivityLinkActivityTarget implements ActivityLinkTarget {
  constructor(public readonly id: number) {}
}

export class ActivityLinkActivityGroupTarget implements ActivityLinkTarget {
  constructor(public readonly id: number) {}
}
